var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"content-header normal"},[_vm._v("\n        "+_vm._s(_vm.headerTitle)+"\n        "),_c('span',{staticClass:"search"},[_vm._t("search")],2),_c('span',{staticClass:"more"},[_vm._t("more")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }